import * as yup from "yup";
import { validarTelefone } from "../../core/utils/validarTelefone";

export const autenticarUsuarioSchema =  yup.object().shape({
  email: yup.string().email("Endereço de e-mail inválido").required("E-mail inválido"),
  senha: yup.string().required("Senha inválida"),
});
  